import "./App.css";
import Home from "./page/Home";
import Photography from "./page/Photography";
import Navbar from "./component/Navbar/navbar";
import Servise from "./page/Service";
import Footer from "./component/Footer/footer";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MusicPlayer from "./component/MusicPlayer/MusicPlayer";
import WhatsAppChat from "./component/WhatsAppChat/WhatsAppChat";
import AdminProjects from "./page/AdminProjects";

function App() {
  return (
    <div className="App">
      <Router>
        <div>
          <Navbar />
        </div>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/photography" element={<Photography />} />
          <Route path="/service" element={<Servise />} />
          <Route path="/admin" element={<AdminProjects />} />
        </Routes>

        <div>
          <Footer />
        </div>

        {/* ── Global floating widgets ── */}
        {/* <MusicPlayer /> */}
        <WhatsAppChat />
      </Router>
    </div>
  );
}

export default App;
